import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClienteMalote } from 'src/app/refact/pages/components/sales/entities/interfacenet/clienteMalote';
import { ReturnPack } from 'src/app/shared/returnPack';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  constructor(private _http : HttpClient) { }

  getClienteByCPF(termo : string): Observable<ReturnPack<ClienteMalote[]>>{
    const url = localStorage.getItem(env.baseApiModuleCRM.toString()) + 'api/v1/ClienteMalote/cpf/';
    return this._http.get<ReturnPack<ClienteMalote[]>>(url + termo);
  }

  getConfig(){
    const url = localStorage.getItem(env.baseApiModuleInfraStructure.toString()) + 'api/v1/ConfiguracaoMalote/versao/0';
    return this._http.get(url);
  }
  
  setCliente(cliente : ClienteMalote, filial : string){
    const url = localStorage.getItem(env.baseApiModuleEcommerce.toString()) + 'api/v1/ClienteMalote/';
    return this._http.post<ClienteMalote>(url + filial, cliente);
  }

  getOccupations()
  {
    const url = localStorage.getItem(env.baseApiModuleCRM.toString()) + 'api/v1/Profissao/versao/0';
    return this._http.get<ReturnPack>(url);
  }

  getAcess(PosAcess: number) {
    let access = new String(localStorage.getItem("ConfigOutras"));
    var ret: any = false;
    if (access.length > PosAcess) {
      switch (PosAcess) {
         default:
          if (Number(access.substring(PosAcess - 1, PosAcess)) >= 1) {
            ret = true;
          } else {
            ret = false;
          }
          break;
      }
    } else {
      ret = false;
    }
    return ret;
  }

  getClienteMaloteByCodigoN(codigoN : string): Observable<ReturnPack> {
    const url = `${localStorage.getItem(env.baseApiModuleCRM.toString())}api/v1/ClienteMalote/codigon/${codigoN}`;
    return this._http.get<ReturnPack>(url);
  }

  cadastrarClienteRapido(cliente: ClienteMalote, filial: string): Observable<ReturnPack<ClienteMalote>> {
    const url = localStorage.getItem(env.baseApiModuleEcommerce.toString()) + 'api/v1/ClienteMalote/';
    return this._http.post<ReturnPack<ClienteMalote>>(url + filial, cliente);
  }
}